import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/pages/products/about-nagase/map02.jpg")